import React, { useEffect, useState } from "react";
// material
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../core/service/users.service";
import { getGrantees } from "../core/service/grantees.service";
// import { styled } from "@mui/material/styles";

// components
import Page from "../components/Page";
import {
  ResearchPeriodExtensionChartAdmin,
  PhDstudentGranteeProgressChartAdmin,
  PostdocGranteeProgressChartAdmin,
  AcceptedPublishedChartAdmin,
  ProgramChartAdmin,
  ResearchPeriodExtensionChartMentor,
  PostdocGranteeProgressChartMentor,
  PhDstudentGranteeProgressChartMentor,
  ContractTimeChartPhd
} from "../components/charts";
import { ProfileView, MentorView } from "../components/profile";
import { UserTable } from "../components/_dashboard/app";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function Profile() {
  const dispatch = useDispatch();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [user, setUser] = useState({});
  const [grantees, setGrantees] = useState([]);

  const getUserProfile = async (id) => {
    const data = await getProfile(id);
    setUser(data);
  };
  const getMentorGrantees = async (id) => {
    const data = await getGrantees(id);
    setGrantees(data?.entities);
  };

  useEffect(() => {
    getUserProfile(id);
    if (role === ROLE_MENTOR) getMentorGrantees(id);
  }, []);

  return (
    <Page title="Profile">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4"> Profile </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ProfileView user={user} />
          </Grid>

          {(role === ROLE_PHD_3Y || role === ROLE_PHD_5Y) && (
            <>
              <Grid item xs={12} md={6} lg={4}>
                <MentorView detail={user?.my_mentor || {}} />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <ContractTimeChartPhd />
              </Grid>
            </>
          )}

          {role === ROLE_ADMIN && (
            <>
              <Grid item xs={12} md={6} lg={4}>
                <ProgramChartAdmin />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <PostdocGranteeProgressChartAdmin />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <PhDstudentGranteeProgressChartAdmin />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <ResearchPeriodExtensionChartAdmin />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <AcceptedPublishedChartAdmin />
              </Grid>
            </>
          )}

          {role === ROLE_MENTOR && (
            <>
              <Grid item xs={12} md={6} lg={4}>
                <ResearchPeriodExtensionChartMentor />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <PostdocGranteeProgressChartMentor />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <PhDstudentGranteeProgressChartMentor />
              </Grid>

              <Grid item xs={12} md={6} lg={12}>
                <UserTable ListUsers={grantees || []} currentUserRole={role} />
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Page>
  );
}
